/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   svg[_ngcontent-%COMP%]{width:100%!important;height:75vh!important}[_nghost-%COMP%]   #process-graph-down[_ngcontent-%COMP%]{width:100%;height:74vh}"];
export { styles as styles };
